module.exports = __webpack_public_path__ + "img/brand-bq1.eace9df1.png";